import { createI18n } from 'vue-i18n';
import zhCN from './zh-CN';
import jaJP from './ja-JP';

// const locale = 'ja-JP';

const getBrowserLocale = () => {
  // const locale = navigator.language;
  // if (locale.startsWith('zh')) {
  //   return 'zh-CN';
  // } else if (locale.startsWith('ja')) {
  //   return 'ja-JP';
  // }
  return 'ja-JP'; // 默认日语区
};

export const i18n = createI18n({
  legacy: false,
  locale: getBrowserLocale(),
  fallbackLocale: 'ja-JP',
  messages: {
    'zh-CN': zhCN,
    'ja-JP': jaJP
  }
});
